import * as THREE from 'three'
import { toDegrees } from '@js/utils'

export class DebugTransformStates{
  private decimales: number = 0
  private model: THREE.Object3D | undefined = undefined

  constructor(model?: THREE.Object3D) {
    this.model = model
  }

  displayRot(object?: THREE.Object3D): string | null {
    if (!object) {
      if (!this.model) {
        console.warn("no model specified.")
        return null
      }
      object = this.model
    }
    return ' - rot:(' +
      toDegrees(object.rotation.x).toFixed(this.decimales) + ',' +
      toDegrees(object.rotation.y).toFixed(this.decimales) + ',' +
      toDegrees(object.rotation.z).toFixed(this.decimales) + ')'
  }

  displayPos(object: THREE.Object3D): string | null {
    if (!object) {
      if (!this.model) {
        console.warn("no model specified.")
        return null
      }
      object = this.model
    }
    return ' - pos:(' +
      object.position.x.toFixed(this.decimales) + ',' +
      object.position.y.toFixed(this.decimales) + ',' +
      object.position.z.toFixed(this.decimales) + ')'
  }

}
